import React from "react";
import { LayoutContentWrapper } from "./layoutWrapper.style";

export default (props) => (
  <LayoutContentWrapper
    style={{ display: "block" }}
    className={props.className != null ? `${props.className} isoLayoutContentWrapper` : "isoLayoutContentWrapper"}
    {...props}
  >
    {props.children}
  </LayoutContentWrapper>
);
